import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {SmartLabelPref} from '../constants';

export const smartLabelsEnabled = () =>
	getPreference(SmartLabelPref.ENABLED, true);
